<template>
  <v-container fluid class="background-green-light mt-lg-16 py-0">
    <v-container class="py-lg-10 py-5 py-sm-8">
      <h5 class="text-white text-lg-h3 text-h5 text-center font-weight-bold">
        {{ $t("home.scheduleYourAppointment") }}
      </h5>
      <v-row class="justify-center my-lg-0 py-3 align-center">
<!--        <v-btn-->
<!--          class="-->
<!--            mx-lg-auto-->
<!--            elevation-0-->
<!--            rounded-xl-->
<!--            background-navy-->
<!--            text-white text-capitalize text-lg-h6-->
<!--            mt-0-->
<!--            font-weight-bold-->
<!--          "-->
<!--          href="https://wa.link/brccem"-->
<!--          target="_blank"-->
<!--        >-->
<!--          {{ $t("home.scheduleAnAppointment") }}</v-btn-->
<!--        >-->
      </v-row>
    </v-container>
  </v-container>
</template>
<script>
export default {
  name: "scheduleYourAppointment",
};
</script>
